<template>
  <div 
    class="offcanvas offcanvas-end border-0 rounded-start-4 overflow-hidden" 
    id="theme-settings-offcanvas" 
    tabindex="-1"
    aria-labelledby="theme-settings-offcanvas-label"
  >
    <div class="d-flex align-items-center bg-primary p-3 offcanvas-header">
      <h5 class="text-white m-0">تنظیمات تم</h5>
      <button 
        aria-label="Close" 
        class="btn-close btn-close-white ms-auto" 
        data-bs-dismiss="offcanvas" 
        type="button"
      ></button>
    </div>
    <div class="offcanvas-body p-0">
      <div class="h-100" data-simplebar="" ref="settingsScrollbar">
        <div class="p-3 settings-bar">
          <!-- Theme Color -->
          <div>
            <h5 class="mb-3 font-16 fw-semibold">طرح رنگ</h5>
            <div class="form-check mb-2">
              <input 
                class="form-check-input" 
                id="layout-color-light" 
                name="data-bs-theme" 
                type="radio" 
                value="light"
                :checked="theme === 'light'"
                @change="setTheme('light')"
              />
              <label class="form-check-label" for="layout-color-light">لایت</label>
            </div>
            <div class="form-check mb-2">
              <input 
                class="form-check-input" 
                id="layout-color-dark" 
                name="data-bs-theme" 
                type="radio" 
                value="dark"
                :checked="theme === 'dark'"
                @change="setTheme('dark')"
              />
              <label class="form-check-label" for="layout-color-dark">دارک</label>
            </div>
          </div>
          
          <!-- Topbar Color -->
          <div>
            <h5 class="my-3 font-16 fw-semibold">رنگ تاپ بار</h5>
            <div class="form-check mb-2">
              <input 
                class="form-check-input" 
                id="topbar-color-light" 
                name="data-topbar-color" 
                type="radio" 
                value="light"
                :checked="topbarColor === 'light'"
                @change="setTopbarColor('light')"
              />
              <label class="form-check-label" for="topbar-color-light">لایت</label>
            </div>
            <div class="form-check mb-2">
              <input 
                class="form-check-input" 
                id="topbar-color-dark" 
                name="data-topbar-color" 
                type="radio" 
                value="dark"
                :checked="topbarColor === 'dark'"
                @change="setTopbarColor('dark')"
              />
              <label class="form-check-label" for="topbar-color-dark">دارک</label>
            </div>
          </div>
          
          <!-- Menu Color -->
          <div>
            <h5 class="my-3 font-16 fw-semibold">رنگ منو</h5>
            <div class="form-check mb-2">
              <input 
                class="form-check-input" 
                id="leftbar-color-light" 
                name="data-menu-color" 
                type="radio" 
                value="light"
                :checked="menuColor === 'light'"
                @change="setMenuColor('light')"
              />
              <label class="form-check-label" for="leftbar-color-light">لایت</label>
            </div>
            <div class="form-check mb-2">
              <input 
                class="form-check-input" 
                id="leftbar-color-dark" 
                name="data-menu-color" 
                type="radio" 
                value="dark"
                :checked="menuColor === 'dark'"
                @change="setMenuColor('dark')"
              />
              <label class="form-check-label" for="leftbar-color-dark">دارک</label>
            </div>
          </div>
          
          <!-- Sidebar Size -->
          <div>
            <h5 class="my-3 font-16 fw-semibold">سایز سایدبار</h5>
            <div class="form-check mb-2">
              <input 
                class="form-check-input" 
                id="leftbar-size-default" 
                name="data-menu-size" 
                type="radio" 
                value="default"
                :checked="menuSize === 'default'"
                @change="setMenuSize('default')"
              />
              <label class="form-check-label" for="leftbar-size-default">دیفالت</label>
            </div>
            <div class="form-check mb-2">
              <input 
                class="form-check-input" 
                id="leftbar-size-small" 
                name="data-menu-size" 
                type="radio" 
                value="condensed"
                :checked="menuSize === 'condensed'"
                @change="setMenuSize('condensed')"
              />
              <label class="form-check-label" for="leftbar-size-small">فشرده</label>
            </div>
            <div class="form-check mb-2">
              <input 
                class="form-check-input" 
                id="leftbar-hidden" 
                name="data-menu-size" 
                type="radio" 
                value="hidden"
                :checked="menuSize === 'hidden'"
                @change="setMenuSize('hidden')"
              />
              <label class="form-check-label" for="leftbar-hidden">مخفی</label>
            </div>
            <div class="form-check mb-2">
              <input 
                class="form-check-input" 
                id="leftbar-size-small-hover-active" 
                name="data-menu-size" 
                type="radio" 
                value="sm-hover-active"
                :checked="menuSize === 'sm-hover-active'"
                @change="setMenuSize('sm-hover-active')"
              />
              <label class="form-check-label" for="leftbar-size-small-hover-active">هاور اکتیو کوچک</label>
            </div>
            <div class="form-check mb-2">
              <input 
                class="form-check-input" 
                id="leftbar-size-small-hover" 
                name="data-menu-size" 
                type="radio" 
                value="sm-hover"
                :checked="menuSize === 'sm-hover'"
                @change="setMenuSize('sm-hover')"
              />
              <label class="form-check-label" for="leftbar-size-small-hover">هاور کوچک</label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="offcanvas-footer border-top p-3 text-center">
      <div class="row">
        <div class="col">
          <button class="btn btn-danger w-100" type="button" @click="resetTheme">
            ریست
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, nextTick } from 'vue'
import { useTheme } from '@/management/composables/useTheme'
import SimpleBar from 'simplebar'

export default {
  name: 'ThemeSettings',
  setup() {
    const { 
      theme, 
      topbarColor, 
      menuColor, 
      menuSize, 
      setTheme, 
      setTopbarColor, 
      setMenuColor, 
      setMenuSize, 
      resetTheme 
    } = useTheme()

    const settingsScrollbar = ref(null)

    onMounted(() => {
      nextTick(() => {
        if (settingsScrollbar.value) {
          new SimpleBar(settingsScrollbar.value)
        }
      })
    })

    return {
      theme,
      topbarColor,
      menuColor,
      menuSize,
      settingsScrollbar,
      setTheme,
      setTopbarColor,
      setMenuColor,
      setMenuSize,
      resetTheme
    }
  }
}
</script>

<style scoped>
/* Ensure offcanvas is hidden by default */
.offcanvas:not(.show) {
  visibility: hidden;
  transform: translateX(100%);
}
</style>
